<template>
    <div class="introducing-user bg-white flex" v-if="user" :class="isInstantChat ? 'is-instant-chat' : ''">
        <div class="basic-profile section flex-wrap">
            <div class="flex-row items-start">
                <UserProfile v-if="user.profile" class="flex-fill" :user="user" :hide-memo="true" />
                <i
                    class="zmdi zmdi-close flex-wrap"
                    v-if="$store.getters.chat && !$store.getters.chat.expire_at && from !== 'ModalSalesTemplate'"
                    @click="$emit('closeIntroducingUser')"
                />
            </div>
        </div>

        <div class="buttons flex-row items-center flex-between flex-wrap">
            <button
                @click="throttle(onClickSendPicture, 1000)"
                class="btn btn-primary send-selected flex-fill m-r-8"
                :style="{ height: '40px' }"
                :class="disabled"
            >
                {{ 'SEND_SELECTED_PICTURES' | translate }}
            </button>
            <button
                @click="throttle(onClickSendAllPictures, 1000)"
                class="btn btn-brd primary send-all flex-fill"
                :style="{ height: '40px' }"
            >
                {{ 'SEND_ALL_PICTURES' | translate }}
            </button>
            <div v-if="from !== 'ModalSalesTemplate'" class="divider flex-wrap" v-html="'ㅣ'" />
            <div v-if="from !== 'ModalSalesTemplate'" class="functions flex-row">
                <div class="button">
                    <ChatButton :class="user | friendType" :user="user" :source_id="$store.getters.chat.user.id" />
                </div>
            </div>
        </div>

        <div class="ver-scroll p-l-16 p-r-16">
            <UserPhotosSelector @onPhotos="photos => (images = photos)" :user="user" />
            <div v-if="(user.profile && user.profile.intro) || user.style" class="additional flex">
                <div :style="{ display: 'flex' }">
                    <div
                        class="m-r-24"
                        :class="from === 'ModalSpreadProfile' ? 'flex-wrap' : 'flex-fill'"
                        v-if="user.profile && (user.profile.intro || user.profile.job_description)"
                    >
                        <UserIntro v-if="user.profile && user.profile.intro" :profile="user.profile" />
                        <JobIntro v-if="user.profile && user.profile.job_description" :profile="user.profile" />
                    </div>
                    <UserStyles
                        v-if="user.style"
                        class="flex-fill"
                        :class="{
                            oneline:
                                user.style &&
                                user.profile &&
                                !user.profile.intro &&
                                !user.profile.job_description &&
                                from !== 'ModalSalesTemplate',
                            'flex-wrap': from === 'ModalSalesTemplate',
                            'flex-fill': from !== 'ModalSalesTemplate',
                        }"
                        :user="user"
                    />
                </div>
                <div class="hr" />
                <LikeTags v-if="user && user.keywords && user.keywords.length !== 0" :user="user" />
                <div class="hr" />
                <DatingStyles
                    v-if="user && user.dating_preferences && user.dating_preferences.length !== 0"
                    :user="user"
                />
                <div v-if="user.profile && user.profile.intro && user.style" class="flex-wrap m-8" />
            </div>
        </div>
    </div>
</template>

<script>
import UserIntro from '@/components/common/UserIntro'
import JobIntro from '@/components/common/JobIntro'
import UserStyles from '@/components/common/UserStyles'
import LikeTags from '@/components/common/LikeTags'
import DatingStyles from '@/components/common/DatingStyles'

export default {
    name: 'IntroducingUser',
    props: ['user', 'from'],
    components: {
        UserIntro,
        JobIntro,
        UserStyles,
        LikeTags,
        DatingStyles,
    },
    data: () => ({
        images: null,
        timer: null,
    }),
    computed: {
        friendTypeAsNumber() {
            return this.$options.filters.friendType(this.user, true)
        },
        disabled() {
            return (this.images || []).filter(img => img.checked).length === 0 ? 'disabled' : ''
        },
        chat() {
            return this.$store.getters.chat || {}
        },
        isInstantChat() {
            return this.$store.getters.chat && this.$store.getters.chat.expire_at
        },
        myPremium() {
            if (this.chat.user.$$premium) {
                const premium = this.$options.filters.hasProduct(this.chat.user, 'premium')
                return this.$store.getters.agent.id === premium.agent_id
            }
            return false
        },
    },
    watch: {
        user() {
            this.images = null
        },
    },
    methods: {
        throttle(handler, delay) {
            if (!this.timer) {
                this.timer = setTimeout(() => {
                    this.timer = null
                }, delay)

                handler()
            }
        },
        onClickSendPicture() {
            const photoUrls = (this.images || []).filter(img => img.checked).map(img => img.photo_url) || []

            if (photoUrls.length === 0) {
                this.$toast.error('SELECT_PICTURES')
                return
            }

            if (this.from === 'ModalSalesTemplate') {
                this.$bus.$emit('importPicturesToModalSpreadProfile', photoUrls)
                return
            }

            this.$bus.$emit('onClickSendPicture', {
                selectedImageUrls: photoUrls,
                source: this.user,
            })
        },
        onClickSendAllPictures() {
            this.$bus.$emit('onRequireSelectAllPhotos')
            this.onClickSendPicture()
        },
    },
}
</script>

<style lang="scss" scoped>
$introducing-basic-profile-height: 216px;
$sending-picture-size: calc((#{$panel-width-introducing-user} - 16px * 2 - 8px) / 2);

.introducing-user {
    $grid-gap: 8px;
    position: relative;
    height: 100%;

    &.is-instant-chat {
        background-color: $grey-09;
        border: none !important;
    }

    .functions {
        .button {
            width: 40px;
            height: 40px;
            background: $grey-02;
        }
    }

    .basic-profile {
        padding: 4px 16px 0;
    }

    .buttons {
        border-top: 1px solid $grey-02;
        padding: 16px;

        .divider {
            color: $grey-03;
            margin: 4px;
            font-size: 20px;
        }

        .send-selected {
            min-width: $sending-picture-size;
        }

        .send-all {
            box-shadow: none;
        }
    }

    .section {
        padding: 20px 16px 24px;
    }

    .additional {
        margin-top: 24px;
        padding-top: 24px;
        padding-bottom: 40px;
        border-top: 1px solid $grey-02;
    }
}
</style>
